export default {
  name: "v-ifas-card-header-button",
  props: {
    type: {
      type: String,
      default: "primary",
      validator: function validator(val) {
        return ["primary", "secondary"].includes(val);
      }
    },
    tooltip: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: "#"
    }
  },
  computed: {
    btnClass: function btnClass() {
      return "ifas-btn-" + this.type;
    },
    hasTooltip: function hasTooltip() {
      return this.tooltip !== null;
    }
  }
};